// Follow-ups in the Guided interview (FOLLOW_UP_PLAN.md §9). The backend keeps, on
// each answer, the decision taken after the main answer; these helpers read where a
// question's exchange stands so the page survives a reload mid-exchange.

// The three lead-ins before a follow-up are used in turn (Admin → Voice Check).
export const LEAD_IN_VARIANTS = 3;

// "none": not answered yet; "follow_up": waiting for the follow-up answer;
// "repeat": the answer couldn't be understood, record it again; "done": exchange over.
export function exchangeStage(answer) {
  if (!answer) return "none";
  const action = answer.decision?.action;
  if (action === "repeat") return "repeat";
  if (action === "follow_up" && answer.follow_up?.text && !answer.follow_up?.transcript) return "follow_up";
  return "done";
}

export function isExchangeDone(answer) {
  return exchangeStage(answer) === "done";
}

// The follow-up, only if the candidate answered it (it is part of the exchange).
export function answeredFollowUp(answer) {
  const f = answer?.follow_up;
  return f?.text && String(f.transcript || "").trim() ? f : null;
}

// F9 for senior, managerial and executive roles (backend follow_up_texts.NO_EXAMPLE_TARGET_SENIOR).
const SENIOR_EXAMPLE_TARGET = "a related example from work";

// The coaching line that matches the probe asked: no "school" for senior roles.
export function exampleTipKey(answer) {
  return answer?.follow_up?.target === SENIOR_EXAMPLE_TARGET ? "rp.exampleTipSenior" : "rp.exampleTip";
}

// Step 5 (backend report_summary.first_answer_tip): what the first answer missed.
const FIRST_ANSWER_TIPS = {
  point: "rp.firstTipPoint",
  result: "rp.firstTipResult",
  example: "rp.firstTipExample",
  role_link: "rp.firstTipRoleLink",
};

export function firstAnswerTipKey(answer) {
  return FIRST_ANSWER_TIPS[answer?.first_answer_tip] || null;
}

// F9: asked for a related example and still none, so the report adds the coaching line.
export function needsExampleTip(answer) {
  const f = answeredFollowUp(answer);
  if (!f || f.kind !== "no_example") return false;
  return (answer.evidence_record || []).some((r) => r.point === "past example" && r.outcome === "missing");
}
